import { useState } from 'react'
import { onChange } from '../../../../../../../utils/types'

const useCreatEdit = () => {
  const [data, setData] = useState<Record<string, unknown>>({})
  const [dataCrud, setDataCrud] = useState<Record<string, unknown>>({})

  const onChange: onChange = ({ target }) => {
    const { name, value } = target
    setData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handledata = (data?: Record<string, unknown>) => {
    setData(data ?? {})
  }

  const onChangeCrud: onChange = ({ target }) => {
    const { name, value } = target
    setDataCrud((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handledataCrud = (data?: Record<string, unknown>) => {
    setDataCrud(data ?? {})
  }

  return { data, onChange, setData, handledata, dataCrud, handledataCrud, onChangeCrud }
}

export { useCreatEdit }
